import type { AppProps } from "next/app";
import Head from "next/head";
import Script from "next/script";

import { Provider } from "react-redux";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";

import Banner from "@components/Banner";

import "../styles/globals.scss";
import "@rainbow-me/rainbowkit/styles.css";

import { getCustomTheme } from "../theme";

import { store } from "../store";
import RudderStackScript from "@components/RudderStackScript";
import AnalyticsMapping from "@constants/analytics_mapping.json";

import WagmiProvier from "@services/WagmiProvider";
import AppLayout from "@components/AppLayout/AppLayout";
import React from "react";

const colors = {
  myScheme: {
    50: "#daffff",
    100: "#b1fbfb",
    200: "#85f7f7",
    300: "#58f3f3",
    400: "#31f0f0",
    500: "#1ed7d7",
    600: "#0ca7a7",
    700: "#007777",
    800: "#004949",
    900: "#001a1a",
  },
};

export const theme = extendTheme({ colors });

const DefaultHead = () => {
  return (
    <>
      <Script
        src="https://attribution.metacrm.inc/tracking-1-2-0.js"
        data-entity-id="653b778fdad2d170612a7af9"
        id="metacrm-tracking"
        integrity="sha384-XXR5g7lSPTOllUzRbn8qgjH1nBfNmJ/wKfvyRO+7r4ldJxMGRCHpjY2jUm8mGsTr"
        crossOrigin="anonymous"
        // @ts-ignore
        apiKey="r7cd59xw9sa"
        ecoSystem="EVM"
      />
      <RudderStackScript fileName={AnalyticsMapping["fileName"]} />
      <Head>
        <title>
          Kelp – The Leading Liquid Restaking Protocol | Restake Ethereum & Stay
          Liquid
        </title>
        <meta
          name="description"
          content="Kelp is a top restaking protocol with $2B+ TVL. Restake Ethereum (ETH) and other assets while maintaining liquidity with rsETH, live on 40+ DeFi platforms. Maximize your DeFi stake rewards today."
        />
        <meta name="robots" content="index, follow" />
      </Head>
    </>
  );
};

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <DefaultHead />
      <ChakraProvider theme={getCustomTheme()}>
        <Provider store={store}>
          <WagmiProvier>
            <Banner variant={1} />
            <AppLayout>
              <Component {...pageProps} suppressHydrationWarning />
            </AppLayout>
          </WagmiProvier>
        </Provider>
      </ChakraProvider>
    </>
  );
}

export default MyApp;
